var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 91,
    viewBox: "0 0 88 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2113 51.5444C35.9629 51.5444 28.8515 51.5444 21.5859 51.5444C34.3007 34.2887 46.9469 17.1529 59.5931 0C59.6274 0.0171358 59.6616 0.0342956 59.6959 0.0514314C57.2969 6.49449 54.8979 12.9375 52.4989 19.3634C50.0999 25.8065 47.6837 32.2324 45.2505 38.7612C52.4818 38.7612 59.6102 38.7612 66.9272 38.7612C54.1096 56.1369 41.3949 73.3755 28.6802 90.6141C28.6459 90.5969 28.5945 90.5798 28.5602 90.5626C33.4268 77.5737 38.2933 64.6191 43.2113 51.5444Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4062 87.2376C35.9485 85.1299 37.4393 83.0736 38.9644 81.0516C39.1015 80.8803 39.5127 80.846 39.7869 80.8631C42.3744 81.1716 44.979 81.223 47.5837 80.9659C56.3915 80.1091 63.9312 76.5449 70.0829 70.2047C76.149 63.9672 79.5248 56.4446 80.1245 47.7568C81.1869 32.2146 72.7219 18.3346 58.4478 12.0801C58.3278 12.0287 58.225 11.9773 58.0536 11.8916C58.859 9.64679 59.6644 7.40201 60.4698 5.15723C78.1025 11.7888 92.3937 32.8658 85.9678 56.4789C79.4734 80.3491 55.4319 92.4469 34.4062 87.2376Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.13 3.10222C52.5707 5.20992 51.0627 7.26621 49.5205 9.30537C49.4006 9.45959 49.0407 9.49385 48.8008 9.45958C46.1448 9.134 43.4887 9.09973 40.8156 9.35677C33.0016 10.1107 26.1302 13.0752 20.2869 18.2845C13.9638 23.9222 10.0739 30.9479 8.72021 39.3101C6.06416 55.7091 14.6835 71.4911 29.8658 78.157C30.02 78.2255 30.1742 78.294 30.3627 78.3969C29.5059 80.6416 28.6663 82.8693 27.8267 85.0969C10.331 78.3626 -3.84028 57.5426 2.44856 33.9809C8.75453 10.4706 32.4361 -2.1756 54.13 3.10222Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnergy);
export default __webpack_public_path__ + "static/media/icon-energy.51034dba12c80d3107b8673dddb552d7.svg";
export { ForwardRef as ReactComponent };